import React, { useState } from 'react';
import styled from 'styled-components';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <NavContainer>
      <NavBar>
        <Logo href="/">
          <span className="highlight-text">Sonor AI</span>
        </Logo>

        <NavLinks className="hidden-tablet hidden-mobile">
          <NavLink href="#why-us">Why Us</NavLink>
          <NavLink href="#mission">Mission</NavLink>
          <NavLink href="#faq">FAQ</NavLink>
          {/* <NavLink href="#works">Works</NavLink> */}
          {/* <NavLink href="#services">Services</NavLink> */}
        </NavLinks>

        <ButtonWrapper className="hidden-tablet hidden-mobile">
          <TalkButton href="https://cal.com/sonorai/intro" target="_blank" rel="noopener noreferrer">
            Let's Talk <ArrowIcon>→</ArrowIcon>
          </TalkButton>
        </ButtonWrapper>

        <MobileMenuToggle
          className="hidden-desktop"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <CloseIcon />
          ) : (
            <>
              <ToggleBar isOpen={isMenuOpen} />
              <ToggleBar isOpen={isMenuOpen} />
            </>
          )}
        </MobileMenuToggle>
      </NavBar>

      {isMenuOpen && (
        <MobileMenu>
          <MobileNavDivider />
          <MobileNavLink href="#why-us">Why Us</MobileNavLink>
          <MobileNavLink href="#mission">Mission</MobileNavLink>
          <MobileNavLink href="#faq">FAQ</MobileNavLink>
          {/* <MobileNavLink href="#works">Works</MobileNavLink> */}
          {/* <MobileNavLink href="/contact">Contact</MobileNavLink>*/}
          <MobileNavDivider />
          <MobileTalkButton href="https://cal.com/sonorai/intro" target="_blank" rel="noopener noreferrer">
            Let's Talk <ArrowIcon>→</ArrowIcon>
          </MobileTalkButton>
        </MobileMenu>
      )}
    </NavContainer>
  );
};

const NavContainer = styled.div`
  position: fixed;
  top: 30px;
  left: 0;
  right: 0;
  z-index: 1000;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
`;

const NavBar = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: rgba(13, 13, 13, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 50px;
`;

const Logo = styled.a`
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text-light);

  .highlight-text {
    color: var(--color-ui-orange);
  }
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const NavLink = styled.a`
  color: var(--color-text-light);
  font-size: 13px;
  font-weight: 500;
  padding: 5px 0;
  transition: color 0.3s ease;

  &:hover {
    color: var(--color-ui-orange);
  }
`;

const NavDropdown = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--color-text-light);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
`;

const DropdownIcon = styled.span`
  font-size: 10px;
  margin-top: 3px;
`;

const ButtonWrapper = styled.div``;

const TalkButton = styled.a`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  background-color: rgba(33, 33, 33, 0.7);
  border-radius: 50px;
  color: var(--color-text-light);
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background-color: var(--color-ui-orange);
  }
`;

const ArrowIcon = styled.span`
  transition: transform 0.3s ease;

  ${TalkButton}:hover & {
    transform: translateX(3px);
  }
`;

const MobileMenuToggle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
`;

const ToggleBar = styled.div`
  width: 24px;
  height: 2px;
  background-color: var(--color-text-light);
  transition: transform 0.3s ease;
`;

const MobileMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 15px;
  padding: 40px 30px;
  background-color: rgba(13, 13, 13, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  margin-top: 10px;
  position: relative;

  .mobile-logo {
    margin-bottom: 10px;
  }
`;

const MobileNavLink = styled.a`
  color: var(--color-text-light);
  font-size: 16px;
  font-weight: 500;
  padding: 8px 0;
  transition: color 0.3s ease;

  &:hover {
    color: var(--color-ui-orange);
  }
`;

const MobileTalkButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: rgb(32, 32, 32);
  color: white;
  font-size: 16px;
  font-weight: 600;
  padding: 15px 30px;
  border-radius: 8px;
  margin-top: 10px;
  width: 100%;
  max-width: 200px;
`;

const MobileNavDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 5px 0;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: rgba(33, 33, 33, 0.7);
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: var(--color-ui-orange);
  }
`;

const CloseIcon = styled.div`
  position: relative;
  width: 16px;
  height: 16px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: var(--color-text-light);
    top: 50%;
    left: 0;
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
`;

export default Navigation;
